import * as React from 'react'
import type {OmitStrict} from 'type-zoo'
import type {TStandardPropertyCard} from '@kapitalist/contract/types'
import DSInlineColorSwatch, {
  type IDSInlineColorSwatchProps,
} from '~/design-system/DSInlineColorSwatch'
import type {TSkin} from '~/game/skins'
import {skins} from '~/game/skins'

export interface INeighborhoodColorSwatchProps extends OmitStrict<
  IDSInlineColorSwatchProps,
  'color'
> {
  color: TStandardPropertyCard
  skin: TSkin
}

const NeighborhoodColorSwatch = ({
  color,
  skin,
  ...dsProps
}: INeighborhoodColorSwatchProps) => (
  <DSInlineColorSwatch {...dsProps} color={skins[skin].hexCodesForColors[color]} />
)

export default NeighborhoodColorSwatch
